import { useTranslation } from 'react-i18next';
import chevronDownIcon from '@ingka/ssr-icon/paths/chevron-down';
import chevronUpIcon from '@ingka/ssr-icon/paths/chevron-up';
import Checkbox from '@ingka/checkbox';
import { useState, useRef } from 'react';
import {
  PillButton,
  PillDropdownContainer,
  DropdownContent,
} from './PillButtonStyles';
import Pill from '@ingka/pill';
import useOutsideClick from '../hooks/useOutsideClick';
import ConditionalRender from './ConditionalRender';
import { PillButtonCompnentProps } from '../types/PillButtonComponent';
import { EventLoyaltyType } from '../types/model';

export const PillButtonComponent: React.FC<PillButtonCompnentProps> = ({
  filterEventState,
  updateFilter,
}): JSX.Element => {
  const [showPill, setShowPill] = useState<boolean>(false);
  const { t } = useTranslation();
  const dropdownIdRef = useRef(
    `pill-dropdown-${Math.random().toString(36).slice(2, 11)}`
  );
  const dropdownId = dropdownIdRef.current;

  const ref = useRef(null);
  useOutsideClick(ref, () => {
    setShowPill(false);
  });

  const onChange = (e: any) => updateFilter(e.target && e.target.value);
  const checkboxes = Object.keys(EventLoyaltyType)
    .map((checkboxField) => {
      const camelizeTranslationKey = (str: string) =>
        str
          .toLowerCase()
          .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase())
          .replace(/^(\w)/g, (firstCharacter) => firstCharacter.toLowerCase());
      return {
        id: checkboxField,
        value: checkboxField,
        label: t(`event.${camelizeTranslationKey(checkboxField)}`),
        checked: filterEventState.includes(checkboxField),
        onChange,
      };
    });

  return (
    <PillButton ref={ref}>
      <Pill
        label={t('event.filter')}
        small={true}
        ssrIcon={showPill ? chevronUpIcon : chevronDownIcon}
        iconPosition="trailing"
        selected={showPill}
        onClick={() => setShowPill(!showPill)}
        aria-haspopup="true"
        aria-expanded={showPill}
        aria-controls={dropdownId}
        aria-pressed={undefined}
      />
      <ConditionalRender predicate={showPill}>
        <PillDropdownContainer id={dropdownId}>
          <DropdownContent role="group" aria-label={t('event.filterOptions')}>
            {checkboxes.map((checkbox, index) => (
              <Checkbox {...checkbox} key={index} />
            ))}
          </DropdownContent>
        </PillDropdownContainer>
      </ConditionalRender>
    </PillButton>
  );
};
